// extracted by mini-css-extract-plugin
export var cardLayout = "_9z-1";
export var paginationContainer = "_9z-0";